<script>
import { mapActions, mapState } from 'vuex'
import { db } from '@/lib/firebase'
import PostData from '../mixins/post-data'
import PostView from './PostView'

export default {
  name: 'PageView',
  components: { PostView },
  mixins: [PostData],
  props: {},

  data: () => ({
    postData: {},
    collectionRef: db.collection('pages')
  }),

  computed: {
    ...mapState(['user']),
    allowEdit () { return !!this.user && (this.user.role === 'admin' || this.user.role === 'editor') },
    postId () {
      return (this.$route.name === 'cv') ? 'cv' : this.$route.params.id
    },
    template () {
      const t = this.postData.template
      const components = ['Residency', 'About', 'Partners']
      return components.includes(t) ? t : null
    }
  },
  watch: {
    $route () {
      if ((this.$route.name !== 'page' && this.$route.name !== 'cv') ||
        this.postData.id === this.$route.params.id) {
        return
      }
      this.unsubscribePost()
      this.subscribeToPost()
    }
  },

  methods: {
    ...mapActions(['showEditor']),
    openEditor () {
      if (this.postData) {
        this.showEditor({
          value: this.postData,
          type: this.postData.id === 'cv' ? 'cv' : 'page'
        })
      }
    }
  }
}
</script>

<template>
  <post-view :post="postData" class="page-view" :class="[this.$route.name]" />
</template>

<style lang="scss">
  .page-view.cv {
    .attachment-box {
      max-width: 500px;
    }
    .attachment {
      grid-column: 2;

      @media (max-width: 600px) {
        grid-column: 1 / -1;
      }
    }
  }
</style>
